import React, { useContext } from 'react'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import { Formik } from 'formik'
import * as Yup from 'yup'
import classNames from 'classnames'
import styles from './enrollment.module.scss'
import { useTranslation } from 'next-i18next'
import SamsungAccountDetailsFields from '@srca-b2b/kp5-ui-common/components/SamsungAccountDetailsFields/SamsungAccountDetailsFields'
import { EnrollmentContext, EnrollmentDispatch } from '../../context/enrollmentContext'
import { useRouter } from 'next/router'
import { correctPTlocale } from '@srca-b2b/kp5-ui-common/utils/helpers'

const EnrollmentStep2 = () => {
  const dispatch = useContext(EnrollmentDispatch)
  const state = useContext(EnrollmentContext)
  const { t } = useTranslation('common')
  const router = useRouter()
  const { registrationData } = state
  const canEditFirstName = registrationData.firstName === null
  const canEditLastName = registrationData.lastName === null

  const getDynamicValidation = () => {
    const validationObj = {
      email: Yup.string().email(t('Invalid_email_address')).required(t('Required'))
    }
    validationObj.firstName = canEditFirstName ? Yup.string().required(t('Required')) : Yup.string()
    validationObj.lastName = canEditLastName ? Yup.string().required(t('Required')) : Yup.string()
    return validationObj
  }

  const schema = Yup.object(getDynamicValidation())

  if (!registrationData.email) {
    const userRegistrationLang = correctPTlocale(router.locale)
    dispatch({
      type: 'STARTED_REGISTRATION',
      payload: { email: state.registrationData.email, locale: userRegistrationLang }
    })
  }

  const onNextClick = (formValues) => {
    dispatch({ type: 'GOTO_STEP_3', payload: formValues })
  }

  return (
    <Container id="enrollment-step2" className={classNames(styles.enrollmentStep2, 'emailForm')}>
      <h4 className={classNames('text-center mb-3 mb-md-4', styles.headerTitle)}>
        {t('Verify_your_Samsung_Account_details')}
      </h4>
      {!registrationData.isInvited && (
        <p className="lead text-center pb-md-2 mb-md-4">{t('Enrollment_Step_2_Invitation_text')}</p>
      )}
      <Formik
        validationSchema={schema}
        onSubmit={onNextClick}
        initialValues={{
          firstName: registrationData.firstName,
          lastName: registrationData.lastName,
          email: registrationData.email
        }}
      >
        {({ handleSubmit, values, isSubmitting }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <div
              className={classNames(styles.formBodyContainer, {
                [styles.subAdmin]: registrationData.isInvited
              })}
            >
              <div className={styles.formBody}>
                <SamsungAccountDetailsFields
                  values={values}
                  canEditFirstName={canEditFirstName}
                  canEditLastName={canEditLastName}
                  columnSize={6}
                />
              </div>
            </div>
            <Row className={styles.enrollmentButtonWrapper}>
              <Col xs="auto">
                <Button
                  type="submit"
                  id="ga-registration-verifysamsungaccount-next"
                  className="btn-registration-next btn-primary arrow-right"
                  disabled={isSubmitting}
                >
                  {t('Next')}
                  <span className={styles.changePageTitle}>: {t('Company_Info')}</span>
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  )
}
export default EnrollmentStep2
